<ngb-tabset #tabs [activeId]="activeTab" type="pills">
    <ngb-tab [id]="'personal'" [title]="'personal_info' | localise">
        <ng-template ngbTabContent class="tab-pane fade show active">
            <app-personal-info-section></app-personal-info-section>
        </ng-template>
    </ngb-tab>
    <ngb-tab [id]="'training'" [title]="'training_info' | localise">
        <ng-template ngbTabContent class="tab-pane fade">
            <app-training-info-section></app-training-info-section>
        </ng-template>
    </ngb-tab>
    <ngb-tab [id]="'body'" [title]="'food_settings' | localise">
        <ng-template ngbTabContent class="tab-pane fade">
            <app-body-section></app-body-section>
        </ng-template>
    </ngb-tab>
    <ngb-tab [id]="'friends'" [title]="'friends' | localise">
        <ng-template ngbTabContent class="tab-pane fade">
            <app-friends-section></app-friends-section>
        </ng-template>
    </ngb-tab>
    <ngb-tab [id]="'delete'" [title]="'delete_user_account' | localise">
        <ng-template ngbTabContent class="tab-pane fade">
            <app-delete-section></app-delete-section>
        </ng-template>
    </ngb-tab>
</ngb-tabset>
